import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { successToast, errorToast } from '../lib/helpers';
import haxios from '../lib/haxios';
import useApi from '../hooks/useApi';
import clsx from 'clsx';
import { 
  UsersIcon, 
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  ShoppingCartIcon
} from '@heroicons/react/24/outline';
import CustomerSpendsTable from '../components/MyVCP/CustomerSpendsTable';
import CustomerContactsGrouped from '../components/MyVCP/CustomerContactsGrouped';
import CommentsTable from '../components/MyVCP/CommentsTable';
import PurchaseTracking from '../components/MyVCP/PurchaseTracking';

function MyVCP() {
  const { uinfo } = useContext(GlobalContext);
  const [activeTab, setActiveTab] = useState('spends');

  // Check if user has access (all sales staff + admins)
  const hasAccess = uinfo?.Status === 'admin' ||
                    uinfo?.Status === 'sales' || 
                    uinfo?.Status === 'rep' || 
                    uinfo?.Position?.toLowerCase().includes('advisor') ||
                    uinfo?.Position?.toLowerCase().includes('rep') ||
                    uinfo?.Position?.toLowerCase().includes('sales');

  if (!hasAccess) {
    return (
      <div className="min-h-screen bg-gray-50 pt-20 p-6">
        <div className="bg-white rounded-lg shadow p-6 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: 'spends', name: 'Customer Spends', icon: UsersIcon },
    { id: 'contacts', name: 'Customer Contacts', icon: ChatBubbleLeftRightIcon },
    { id: 'comments', name: 'Comments', icon: DocumentTextIcon },
    { id: 'purchases', name: 'Purchase Tracking', icon: ShoppingCartIcon }
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-indigo-100 rounded-lg">
            <UsersIcon className="w-6 h-6 text-indigo-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">My VCP Dashboard</h1>
            <p className="text-sm text-gray-600 mt-1">Personal dashboard for sales staff</p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-6">
        <div className="flex space-x-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={clsx(
                  'flex items-center space-x-2 px-4 py-3 border-b-2 font-medium text-sm transition-colors',
                  activeTab === tab.id
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                )}
              >
                <Icon className="w-5 h-5" />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-6">
        {activeTab === 'spends' && <CustomerSpendsTable />}
        {activeTab === 'contacts' && <CustomerContactsGrouped />}
        {activeTab === 'comments' && <CommentsTable />}
        {activeTab === 'purchases' && <PurchaseTracking />}
      </div>
    </div>
  );
}

export default MyVCP;

